<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >   
       <div v-if="needInit">{{initData()}}</div>  

       <v-layout row wrap>
            <v-flex xs6> <v-card outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <a-course v-bind:ltype="1"></a-course>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <a-course v-bind:ltype="2"></a-course>
            </v-card>  </v-flex>
            <v-flex>
                <v-card xs2>
                    <v-card-title>
                        Program code settings:
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                                <v-text-field
                                        label="Code file extension:" 
                                        prefix="."
                                        style="margin:10    px"
                                        v-model="extension">
                                </v-text-field>
                           
                        </v-row>
                        <v-row>
                            Autocompletion template:
                        </v-row>
                        <v-row>
                            <v-overflow-btn
                                style = "margin: 10px"
                                :items="cmModes"
                                label="Select template..."
                                v-model="autocompletion"
                                item-value="text"
                            ></v-overflow-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs5>
                <v-card>
                    <v-card-title>
                        Execution and support files:
                    </v-card-title>
                    <v-card-text>


                    <div>
                        <v-tabs
                            center-active 
                            color="blue" slider-color="blue"
                            class="customTabTitle"
                            >
                            <v-icon @click="addElement(1)">mdi-plus-circle-outline</v-icon>
                            <v-tab v-for="(f, index) in files" :key="index" @click="setActiveContent(1,index)">                                    
                                {{f.filename}} &nbsp;
                                <v-icon v-if="index>2" small @click="editTab(1,index)">mdi-pencil</v-icon>
                                <v-icon v-if="index>2" small @click="deleteElement(1,index)">mdi-delete</v-icon>
                            </v-tab>
                        </v-tabs>
                        <v-text-field
                            v-if="editNo == 1"
                            label="Change name (and press Enter)"
                            v-model="chanName.name"
                            @keydown.enter.prevent="changeTabName(1)"
                            @keydown.esc.prevent="editNo = 0"
                        ></v-text-field>
                        <codemirror class="border-top" ref="myCm" v-model="files[activeIndex].filecontent" 
                            :options="cmOptions"
                            >
                        </codemirror>
                    </div>



                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs5>
                <v-card>
                    <v-card-title>
                        Keeping files:
                    </v-card-title>
                    <v-card-text>


                    <div>
                        <v-tabs
                            center-active 
                            color="blue" slider-color="blue"
                            class="customTabTitle"
                            >
                            <v-icon @click="addElement()">mdi-plus-circle-outline</v-icon>
                            <v-tab v-for="(f, index) in keepfiles" :key="index" @click="setActiveContent(2,index)">                                    
                                {{f.filename}} &nbsp;
                                <v-icon small @click="editTab(2,index)">mdi-pencil</v-icon>
                                <v-icon v-if="index>0" small @click="deleteElement(2,index)">mdi-delete</v-icon>
                            </v-tab>
                        </v-tabs>
                        <v-text-field
                            v-if="editNo == 2"
                            label="Change name (and press Enter)"
                            v-model="chanName.name"
                            @keydown.enter.prevent="changeTabName(2)"
                            @keydown.esc.prevent="editNo = 0"
                        ></v-text-field>
                        <codemirror class="border-top" ref="myCm" v-model="keepfiles[activeIndex_keep].filecontent" 
                            :options="cmOptions"
                            >
                        </codemirror>
                    </div>



                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                        <v-flex xs4>
                            <p>Area:
                                <v-menu v-if="areaList.length > 0" transition="slide-y-transition" bottom right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn large class="my-3" color="primary" v-on="on">
                                            {{ areaList[areaIndex].name}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in areaList"
                                            :key="index"
                                            @click="areaIndex = index; areaID = item.id;"
                                        >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>  
                                </v-menu>
                            </p>
                        </v-flex>

                            <v-flex xs6>
                                <v-card outlined>
                                    <v-btn @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ACourse from '../ACourse.vue'
import LanguageList from '../LanguageList.vue'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/shell/shell.js'
import {mapGetters} from 'vuex'
import axios from '../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             contentUni: null,
             needInit : true,
             myID: 0,
             areaID: 0,
             areaIndex : 0,
             myOrder: 0,
             areaList: [],
             extension : '',
             cmModes: ['text/css','text/html','text/javascript','text/x-python','text/x-java', 'text/x-sql', 'text/x-php', 'text/x-c++src', 'text/x-csharp', 'text/x-objectivec', 'text/x-scala', 'text/x-sh'],
             autocompletion: '',
             files: [ {
                        filename: 'vpl_run.sh',
                        filecontent: ''
                        }, {
                        filename: 'vpl_debug.sh',
                        filecontent: ''
                        }, {
                        filename: 'vpl_evaluate.sh',
                        filecontent: ''
                        }
                    ],
            keepfiles : [ {
                        filename: 'keep1',
                        filecontent: ''
                        }
                    ],
             cmOptions: {
                    tabSize: 4,
                    styleActiveLine: true,
//                    highlightDifferences: true, 
                    lineNumbers: true,
                    line: true,
                    mode: 'text/x-sh',
                    lineWrapping: false,
                    extraKeys: {'Ctrl-Space': 'autocomplete',
                            'F11'(cm) {
                                cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                            },
                            'Esc'(cm) {
                            if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                        }
                    }
                },
                editNo: 0,
                chanName: {name:'', index:0}, // model for renaming
                activeIndex: 0,
                activeIndex_keep: 0
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContentUni',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig'                        
                    ])
    ,
    components: {
        ACourse,
        LanguageList,
        codemirror 
    },
    methods : {
        prepareDataforSave() {

            //// xxxxx check data - are there some data to fill?

            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            const data = this.getAllContentUni

            this.contentUni = {
                course_id : this.myID,
                area_id: this.areaID,
                course_order: this.myOrder,
                file_extension: this.extension,
                editor_template: this.autocompletion,
                file_list: JSON.stringify (this.files),
                keep_list: JSON.stringify (this.keepfiles),
                content_list: []
            }
            
            for(var key in data) {
                this.contentUni.content_list.push( {
                    lang_id : key.replace('l',''),
                    content : data[key]
                })
            }

            // axios
            axios.post('/create-edit-course-all-lang', this.contentUni, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })     
        },
        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'courses', params: {id: this.areaID}})   
        },
        initData() {
            this.needInit = false            
            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.myID = this.$route.params.id
            this.areaID = this.$route.params.area_id

            if (this.myID == '0') {
                this.$store.commit('prepareUni','course')
            } else {
            // load existing data
                axios.get('/get-course-in-all-lang/' + this.$route.params.id, this.$store.getters.getAxiosConfig )
                .then(res => {
                    const data = {                        
                        cType: 'course',
                        content_list : res.data.list
                    }

                    this.$store.dispatch('setFullContentUni', data)
                    this.myOrder = res.data.course_order   
                    this.extension = res.data.file_extension  
                    this.autocompletion = res.data.editor_template
                    if (res.data.file_list.length > 1)
                        this.files = JSON.parse(res.data.file_list)
                    if (res.data.keep_list.length > 1)
                        this.keepfiles = JSON.parse(res.data.keep_list)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            } 
            
            axios.get('/get-areas/' + this.$route.params.category_id, this.$store.getters.getAxiosConfig )
            .then(res => {
                this.areaIndex = 0
                this.areaList = []
                for(let i = 0; i < res.data.areas.length; i++) {
                    this.areaList.push( {
                        id: res.data.areas[i].id,
                        name: res.data.areas[i].area_name
                    })
                    // set index in list
                    if (res.data.areas[i].id == this.areaID) this.areaIndex = i
                 }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        addElement(where) {
            if (where == 1) {
                this.files.push( {
                    filename : 'file' + (this.files.length+1),
                    filecontent : ''
                })
            } else {
                this.keepfiles.push( {
                    filename : 'keep' + (this.keepfiles.length+1),
                    filecontent : ''
                })
            }
        },
        editTab(where, index) {
            if (where == 1) {
                this.chanName.name = this.files[index].filename
            } else {
                this.chanName.name = this.keepfiles[index].filename
            }
            this.chanName.index = index
            this.editNo = where 
        },
        changeTabName(where) {
            if (where == 1) {
                this.files[this.chanName.index].filename = this.chanName.name
            } else {
                this.keepfiles[this.chanName.index].filename = this.chanName.name
            }
            this.editNo = 0
        },
        setActiveContent(where,index) {
            if (where == 1) {
                this.activeIndex = index            
            } else {
                this.activeIndex_keep = index
            }
        },
        deleteElement(where,index) {
            if (where == 1) {
                this.files.splice(index, 1)
                if (this.activeIndex > this.files.length-1)  this.activeIndex = this.files.length-1
                this.editNo = 0
            } else {
                this.keepfiles.splice(index, 1)
                if (this.activeIndex_keep > this.keepfiles.length-1)  this.activeIndex_keep = this.keepfiles.length-1
                this.editNo = 0

            }
        }
    },
    mounted() {        
        this.needInit = true
    } 
          
     
}
</script>


